module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "frame-21-2.5a555d7e.svg";